/** @file The sector table an entry names: the puppet's own tables first, then the given built-ins. */
import { ERROR_CODES } from '@zilo/pose3d-format/errors/codes';
import type { SectorTable } from '@zilo/pose3d-format/types/facet';
import type { Puppet } from '@zilo/pose3d-format/types/puppet';
import { throwError } from '@zilo/pose3d-std/errors/throwError';

/** `puppet.sectorTables[id]`, else `builtins[id]`; throws `SECTOR_TABLE_UNKNOWN` at `path` otherwise. */
export function tableOf(id: string, puppet: Pick<Puppet, 'sectorTables'>, builtins: Readonly<Record<string, SectorTable>>, path: string): SectorTable {
  const own = puppet.sectorTables ?? {};
  if (Object.hasOwn(own, id)) return own[id] as SectorTable;
  if (Object.hasOwn(builtins, id)) return builtins[id] as SectorTable;
  return throwError(ERROR_CODES.SECTOR_TABLE_UNKNOWN, { table: id }, { path, hint: 'a built-in table or a key of puppet.sectorTables' });
}
